import { Footer } from "./Components/Footer.tsx";
import { Header } from "./Components/Header.tsx";
import { Space } from "@mantine/core";
import { Outlet, ScrollRestoration } from "react-router";
import { usePageviewTracking } from "./hooks/usePageviewTracking.ts";

export const App = () => {
  usePageviewTracking();

  return (
    <>
      <ScrollRestoration />
      <Header />
      <Space h="xl" />

      <Outlet />

      <Space h="xl" />
      <Footer />
      <Space h="xl" />
    </>
  );
};

export default App;
